import Section from "@wrappers/Section";

export default function Footer() {
	return <footer>
		<Section className="has-text-centered pt-6 pb-4">
			<span className="has-text-grey">גן מדבר סמר © {new Date().getFullYear()}</span>
		</Section>
	</footer>;
}